import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-layout",
  "use": "icon-layout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-layout\" id=\"icon-layout\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" /><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\" /><line x1=\"9\" y1=\"21\" x2=\"9\" y2=\"9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol